import { render, staticRenderFns } from "./fvTextarea.vue?vue&type=template&id=6bf3fefe&lang=pug&"
import script from "./fvTextarea.vue?vue&type=script&lang=js&"
export * from "./fvTextarea.vue?vue&type=script&lang=js&"
import style0 from "./fvTextarea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvTextarea.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvTextarea.vue
// module id = 154
// module chunks = 0 1